<div class="c-configuration-preview-container">
  <div class="c-preview">
    <div class="c-preview-container">
      <div class="radio-container">
        <mat-radio-group [(ngModel)]="view">
          <div>
            <mat-radio-button
              [disabled]="action === 'view'"
              (change)="changeView($event)"
              value="mobile"
              class="u-margin-top-20"
              >Mobile</mat-radio-button
            >
          </div>
          <div>
            <mat-radio-button
              [disabled]="action === 'view'"
              (change)="changeView($event)"
              value="tablet"
              class="u-margin-top-20 u-margin-bottom-20"
              >Tablet</mat-radio-button
            >
          </div>
        </mat-radio-group>
      </div>
      <div class="c-tablet" *ngIf="view === viewType.TABLET">
        <div class="c-header tablet" [ngStyle]="{ 'background-color': 'black' }">
          <!-- <img *ngIf="headerImage" [src]="headerImage" /> -->
        </div>
        <div class="c-tablet-content">
          <div
            [ngStyle]="{ 'background-image': 'url(' + landscapeImage + ')' }"
            class="c-tablet-panel-1 c-image-panel u-height-10000 u-position-center"
          ></div>
        </div>
        <div class="c-footer tablet" [ngStyle]="{ 'background-color': 'black' }">
          <!-- <img *ngIf="footerImage" [src]="footerImage" /> -->
        </div>
      </div>
      <div class="c-mobile" *ngIf="view === viewType.MOBILE">
        <div class="c-header mobile" [ngStyle]="{ 'background-color': 'black' }">
          <!-- <img *ngIf="headerImage" [src]="headerImage" /> -->
        </div>
        <div class="c-mobile-content">
          <div
            [ngStyle]="{ 'background-image': 'url(' + portraitImage + ')' }"
            class="c-mobile-panel-1 c-image-panel u-height-10000 u-position-center"
          ></div>
        </div>
        <div class="c-footer mobile" [ngStyle]="{ 'background-color': 'black' }">
          <!-- <img *ngIf="footerImage" [src]="footerImage" /> -->
        </div>
      </div>
    </div>
  </div>
</div>
